<div class="container">
    <section class="inner-container">
        <div class="products" style="background: white; ">
  <div class="content-container">
    <div class="text-center">
      <h1 class="title-default intro-title">Online Banking UAT/ Live Payee Code</h1>
      <hr class="yellow-line-large">
      <p class="text-intro"></p>


    </div>
    <div class="inner">
      <div class="flex-wrap scroll_cards_uat_live">
            <form name="ob-payee-code-form" id="ob-payee-code-form" data-k2-validation="true" class="col-sm-10" style="padding: 0" (ngSubmit)="submit(true)">
              
                
                <div class="row mrgn-btm-1rem">
                    <div class="box-uat col-md-6">
                        <h3 class="title-primary"><strong>Payee Code </strong></h3>
                        <h4 class="mrgn-btm-1rem">Your website developer will need the payee code to successfully integrate to Maybank2u Pay Payment Gateway. Please consult your website developer on the usage of this payee code.</h4> 
                        <div class="row">
                            <div class="col-md-12">
                              <h4> Payee Code for User Acceptance Testing:</h4>
                              <br>
                              <div class="col-md-12">
                                    <input class="form-control text-center" readonly="" [value]="m2uPay?.payee_code_uat">
                                </div>
                            </div>
                        </div>

                        <div *ngIf="m2uPay?.payee_code_prod && submissionDetailService.tagExists(submissionDetailService.getCurrentSubmissionId(),CONSTANT.STATUS.ONLINE_BANKING.APPLICATION_PROCESS_COMPLETED)" class="row">
                            <div class="col-md-12">
                              <h4> Payee Code for Go-Live / Production:</h4>
                              <br>
                              <div class="col-md-12">
                                    <input class="form-control text-center" readonly="" [value]="m2uPay?.payee_code_prod">
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="box-uat col-md-6">
                        <h3 class="title-primary"><strong>Payment Reporting</strong></h3>
                        <div class="col-md-12">
                            <div class="form-group">
                                <h4>Your “Daily Payment Summary Report” and “Payment Raw Data File (in details)” are available on the Maybank Payee Report Portal. <br>For security reason, your username and password will be sent to your mailbox once your application approved.</h4>
                                <br>
                                <div class="col-md-12">
                                    <input class="form-control text-center" readonly="" value="https://payee.maybank2u.com.my/payee/LogIn.do?">
                                </div>
                            </div>
                        </div>

                    </div>

                 
                </div>  


                

                <div class="row">
                  <div class="box-uat col-md-12 mrgn-btm-1rem">
                    
                    <h3 class="title-primary"><strong>User Acceptance Test (UAT) Confirmation </strong></h3>
                        
                  </div>
                  <div class="box-uat col-md-6 mrgn-btm-1rem">
                    <div class="group">

                      <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-12">
                                    <h5>
                                        Upload screenshot of the payment pop-up for UAT environment* <br>
                                    </h5>
                                    <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="uatPopUpSc">
                                        <input (change)="addDoc('uat_test_pop_up_sc', $event, false, submissionId)" accept=".pdf, application/pdf,image/jpg, image/jpeg, image/png" #uatPopUpScInput type="file" name="uatPopUpSc"/>
                                    </div>
                                    <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="!uatPopUpSc">
                                        <a [href]="getFileUrl(uatPopUpSc)" download class="link" title="Download">Download</a>&nbsp; &emsp;
                                        <a *ngIf="!uatCompleted" (click)="uatPopUpSc = null; uatPopUpScInput.value = ''; uploader.queue[0].progress = 0; deleteDoc('uat_test_pop_up_sc')" class="link">Delete</a>
                                    </div>
                                </div>
                            </div>
                            <div class="row" [hidden]="valid || docsValid">
                                <div class="col-md-12">
                                    <label class="red">All documents marked with a * are required</label>
                                </div>
                            </div>
                            
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="box-uat col-md-6">
                    <div class="group">

                      <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-12">
                                    <h5>
                                        Upload screenshot of the Realtime Payment Notification received * <br>
                                    </h5>
                                    <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="uatRPNSc">
                                        <input (change)="
                                        addDoc('uat_test_rpn_sc', $event, false, submissionId)" accept=".pdf, application/pdf,image/jpg, image/jpeg, image/png" #uatRPNScInput type="file" name="uatRPNSc"/>
                                    </div>
                                    <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="!uatRPNSc">
                                        <a [href]="getFileUrl(uatRPNSc)" download class="link" title="Download">Download</a>&nbsp; &emsp;
                                        <a *ngIf="!uatCompleted" (click)="uatRPNSc = null; uatRPNScInput.value = ''; uploader.queue[0].progress = 0; deleteDoc('uat_test_rpn_sc')" class="link">Delete</a>
                                    </div>
                                </div>
                            </div>
                            <div class="row" [hidden]="valid || docsValid">
                                <div class="col-md-12">
                                    <label class="red">All documents marked with a * are required</label>
                                </div>
                            </div>
                            
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="box-uat col-md-12">
                    <div class="group">

                        <div class="row">
                            <div *ngIf="uploader" [hidden]="uatPopUpSc">
                                Upload Progress: {{uploader.queue[0] ? uploader.queue[0].progress : 0}}%
                                <div class="progress">
                                    <div class="progress-bar progress-bar-success" role="progressbar" [ngStyle]="{ 'width': (uploader.queue[0] ? uploader.queue[0].progress : 0) + '%' }">
                                        <span style="opacity: 0">...</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                  </div>
                  

                </div>

                <div *ngIf="!uatCompleted" class="row" style="text-align: initial;">
                    <div class="col-md-12">
                        <div class="checkbox-default">
                            <label class="norm" for="doneUat"> 
                                <input type="checkbox" name="doneUat" [(ngModel)]="doneUat" id="doneUat" ><span></span>
                                I/We hereby CONFIRM that the User Acceptance Test for Maybank2u Pay was successful with no open defect/issues and ready to go to Production. 
Maybank shall not be held responsible for any failure due to improper/incomplete Payee User Acceptance Test.
                            </label>
                            <br>
                        </div>
                    </div>
                </div>
              <div  id="save_cards_uat_live" *ngIf="!uatCompleted">
                <div class="col-md-3">
                  
                </div>
                <div class="col-md-6">
                </div>         
                <div class="col-md-3">
                  <button type="submit" class="btn btn-primary btn-block center" >Submit</button>
                </div>   

                
              </div>
            </form>
      </div>
    </div>
  </div>
</div>
</section>
</div>
